import { Box } from '@mui/material'
import ManageWebApi from 'api/application/manageWeb'
import { ReviewProps } from 'api/application/manageWeb-interface'
import BtnAdd from 'assets/button/BtnAdd'
import Loading from 'component/Loading'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import MainButton from 'new-components/buttons/main-button'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ReviewForm from './review-form'
import ReviewList from './review-list'

type ErrorMessage = {
    EMPTY_TOPIC?: string
}

const Review = () => {
    const { t } = useTranslation()
    const t_REVIEW = "MANAGE_WEB.REVIEW"

    const [load, setLoad] = useState<boolean>(true)
    const [statusDel, setStatusDel] = useState<boolean>(false)
    const [statusAdd, setStatusAdd] = useState<boolean>(false)

    const [dataReview, setDataReview] = useState<any>([])
    const [isEdit, setIsEdit] = useState<boolean>(false)
    const [dataEdit, setDataEdit] = useState<any>({})
    const [dataEditId, setDataEditId] = useState<any>({})

    const [errorMessage, setErrorMessage] = useState<ErrorMessage>({ EMPTY_TOPIC: '' });


    const loadData = async () => {
        setLoad(true)
        await ManageWebApi.getReview().then((res) => {
            const newData = res.data.map((item: any, index: number) => {
                return { ...item, sorting: index + 1 }
            })
            setDataReview(newData)
        }).catch(() => {
            return
        }).finally(() => {
            setLoad(false)
        })
    }

    useEffect(() => {
        loadData()
    }, [])

    const onEdit = (status: boolean, item?: any) => {
        if (item) {
            setDataEdit(item)
            setDataEditId(item)
        }
        if (!status) {
            setDataEdit({})
            setDataEditId({})
        }
        setIsEdit(status)
    }

    const onSave = async () => {
        if (!dataEdit?.topic) {
            return setErrorMessage({
                EMPTY_TOPIC: !dataEdit?.topic ? t('MANAGE_WEB.REVIEW.VALIDATION.REVIEW_NAME') : '',
            })
        }
        setStatusAdd(true)
        const id = dataEditId?.reviewId || 0
        const newPayload: ReviewProps = dataEdit
        if (id === 0) {
            const res = await ManageWebApi.createReview(newPayload)
            if (res === "pass") {
                onEdit(false)
                loadData()
                notiSuccess(t(`${t_REVIEW}.SAVE_SUC`))
                setErrorMessage({ EMPTY_TOPIC: '' })
            } else {
                notiError(t(`${t_REVIEW}.SAVE_ERROR`))
            }
        } else {
            const res = await ManageWebApi.updateReview(id, newPayload)
            if (res === "pass") {
                onEdit(false)
                loadData()
                notiSuccess(t(`${t_REVIEW}.SAVE_SUC`))
                setErrorMessage({ EMPTY_TOPIC: '' })
            } else {
                notiError(t(`${t_REVIEW}.SAVE_ERROR`))
            }
        }
        setStatusAdd(false)
    }

    return (
        <Box>
            <Loading show={load} />
            <Box display="flex" flexDirection="column" height="100%">
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Box fontSize={20} fontWeight={600}>
                        {t(`${t_REVIEW}.TITLE`)}
                    </Box>
                    {!isEdit ? (
                        <Box>
                            <MainButton
                                startIcon={<BtnAdd width='20px' height='20px' />}
                                title={t(`${t_REVIEW}.BTN_ADD`)}
                                onClick={() => { onEdit(true) }}
                                type="primary"
                                variant='contained'
                                style={{ width: 120 }}
                            />
                        </Box>
                    ) : (
                        <Box display="flex" alignItems="center" gap={1}>
                            <MainButton
                                variant="outlined"
                                type="secondary"
                                title={t(`${t_REVIEW}.BTN_CANCEL`)}
                                onClick={() => {
                                    onEdit(false);
                                    setErrorMessage({ EMPTY_TOPIC: '' })
                                }}
                                style={{ width: 120 }}
                            />
                            <MainButton
                                title={t(`${t_REVIEW}.BTN_SAVE`)}
                                disabled={statusAdd}
                                type="primary"
                                variant="contained"
                                onClick={() => { onSave() }}
                                style={{ width: 120 }}
                            />
                        </Box>
                    )}
                </Box>
                <Box my={4} height="100vh" overflow="auto">
                    {!isEdit ? (
                        <ReviewList dataList={dataReview} onEdit={onEdit} statusDel={statusDel} reLoad={loadData} />
                    ) : (
                        <ReviewForm dataEdit={dataEdit} setDataEdit={setDataEdit} errorMessage={errorMessage} />
                    )}
                </Box>
            </Box>
        </Box>
    )
}

export default Review